import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import CustomIcons from "@/assets/CustomIcons";

Vue.use(Vuetify);

const vuetifyInstance = new Vuetify({
  theme: {
    dark: false,
    default: "light",
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: "#003869",
        primaryLighten80: "#304860",
        primaryLightGrey75: "#F6F4F2",
        primary2: "#00B6ED",
        mainGrey100: "#666666",
        secondary: "#001F3D",
        secondary50: "#607283",
        secondary2: "#6CCBF7",
        secondary3: "#C5E2F0",
        neutralLighten100: "#F1EEEC",
        lightGrey100: "#F1EEEC",
        neutralDark50: "#E0DCD8",
        neutralDark75: "#CFC9C4",
        darkGrey25: "#E9E6E3",
        darkGrey75: "#CFC9C4",
        darkGrey100: "#BDB6B0",
        accent: "#00B6ED",
        accentDarker110: "#085A8B",
        success100: "#17B26A",
        warning100: "#FDB022",
        error: "#FF5252",
        error100: "#D32F2F",
        info: "#3355FF",
        info100: "#2970FF",
        success: "#17B26A",
        warning: "#FFC107",
        warning50: "FFFAEB",
        warning110: "DC6803",
        //  new DFI colors
        //  CONTENT
        ContentPrimary: "#121212",
        ContentSecondary: "#333333",
        ContentTertiary: "#666666",
        ContentDisabled: "#B2B2B2",
        ContentPrimaryStatic: "#121212",
        ContentSecondaryStatic: "#333333",
        //  Content Inverse
        ContentInversePrimary: "#FFFFFF",
        ContentInverseSecondary: "#E5E5E5",
        ContentInverseTertiary: "#B2B2B2",
        ContentInversePrimaryStatic: "#FFFFFF",
        ContentInverseSecondaryStatic: "#E5E5E5",
        //  Brand
        ContentBrandPrimaryDefault: "#00B6ED",
        ContentBrandPrimaryHover: "#085A8B",
        ContentBrandPrimarySubtle: "#6CCBF7",
        ContentBrandSecondary: "#001F3D",
        //  Info
        ContentInfoPrimary: "#3355FF",
        ContentInfoSecondary: "#2944CC",
        ContentInfoDefault: "#3355FF",
        ContentInfoHover: "#2944CC",
        ContentInfoPressed: "#1F3399",
        //  Warning
        ContentWarningPrimary: "#FFCC00",
        ContentWarningSecondary: "#A15C07",
        //  Negative
        ContentNegativePrimary: "#E50000",
        ContentNegativeSecondary: "#B70000",
        //  Positive
        ContentPositivePrimary: "#17B26A",
        ContentPositiveSecondary: "#009850",

        //  BACKGROUND
        BackgroundPrimaryDefault: "#FFFFFF",
        BackgroundPrimaryHover: "#F2F2F2",
        BackgroundPrimaryPressed: "#E5E5E5",
        BackgroundSecondary: "#D9D9D9",
        BackgroundDisabled: "#F2F2F2",
        //  Elevated - for components inside dialogs
        BackgroundElevatedPrimaryDefault: "#FFFFFF",
        BackgroundElevatedPrimaryHover: "#F2F2F2",
        BackgroundElevatedSecondaryDefault: "#FAF9F9",
        BackgroundElevatedSecondaryHover: "#F6F4F2",
        //  Inverse
        BackgroundInverse: "#121212",
        //  Brand
        BackgroundBrandPrimary: "#00B6ED",
        BackgroundBrandPrimaryHover: "#085A8B",
        BackgroundBrandPrimaryPressed: "#022E50",
        BackgroundBrandPrimarySubtle: "#DBE8EE",
        BackgroundBrandSecondary: "#304860",
        BackgroundBrandSecondaryHover: "#001F3D",
        BackgroundBrandTertiary: "#FAF9F9",
        BackgroundBrandTertiaryHover: "#F6F4F2",
        BackgroundBrandTertiaryPressed: "#F1EEEC",
        //  Info
        BackgroundInfoPrimary: "#3355FF",
        BackgroundInfoSecondary: "#EFF1FF",
        //  Warning
        BackgroundWarningPrimary: "#FFCC00",
        BackgroundWarningSecondary: "#FFFAEB",
        //  Negative
        BackgroundNegativePrimary: "#E50000",
        BackgroundNegativeSecondary: "#FDECEC",
        BackgroundNegativeStatic: "#E50000",
        //  Positive
        BackgroundPositivePrimary: "#17B26A",
        BackgroundPositiveSecondary: "#ECFDF3",
        //  Tooltip
        BackgroundTooltip: "#0D0D0D",
        //  DataViz
        BackgroundDataVizPositive: "#CAFCDE",
        BackgroundDataVizWarning: "#FFF3D0",
        BackgroundDataVizNegative: "#FFDDDD",
        BackgroundDataVizTrendEvent: "#117066",
        BackgroundDataVizInfoEvent: "#9AA2B5",

        //  BORDER
        BorderPrimary: "#666666",
        BorderSecondary: "#999999",
        BorderDisabled: "#CCCCCC",
        //  Elevated - for components inside dialogs
        BorderElevatedPrimary: "#666666",
        BorderElevatedSecondary: "#F1EEEC",
        //  Brand
        BorderBrandPrimary: "#00B6ED",
        BorderBrandPrimarySubtle: "#99D6F4",
        BorderBrandSecondary: "#E9E6E3",
        BorderBrandSecondaryHover: "#CFC9C4",
        BorderBrandTertiary: "#F1EEEC",
        //  Inverse
        BorderInverse: "#FFFFFF",
        //  Info
        BorderInfoPrimary: "#3355FF",
        BorderInfoSecondary: "#D6DDFF",
        //  Warning
        BorderWarningPrimary: "#FFCC00",
        BorderWarningSecondary: "#FFEB99",
        //  Negative
        BorderNegativePrimary: "#E50000",
        BorderNegativeSecondary: "#FACCCC",
        //  Positive
        BorderPositivePrimary: "#17B26A",
        BorderPositiveSecondary: "#8BD8B4",

        //  OVERLAY
        // Overlay50: "#00000080",
        // Overlay50Inverse: "#FFFFFF80",

      },
      dark: {
        primary: "#FFFFFF",
        secondary: "#333333",
        success: "#2EBA79",
        warning: "#FFD633",
        error: "#EA3333",
        accent: "#00B6ED",
        info: "#5C77FF",
        //  new DFI colors
        //  CONTENT
        ContentPrimary: "#FFFFFF",
        ContentSecondary: "#E5E5E5",
        ContentTertiary: "#B2B2B2",
        ContentDisabled: "#4D4D4D",
        ContentPrimaryStatic: "#121212",
        ContentSecondaryStatic: "#333333",
        //  Content Inverse
        ContentInversePrimary: "#121212",
        ContentInverseSecondary: "#333333",
        ContentInverseTertiary: "#666666",
        ContentInversePrimaryStatic: "#FFFFFF",
        ContentInverseSecondaryStatic: "#E5E5E5",
        //  Brand
        ContentBrandPrimaryDefault: "#00B6ED",
        ContentBrandPrimaryHover: "#6CCBF7",
        ContentBrandPrimarySubtle: "#043D64",
        ContentBrandSecondary: "#BDB6B0",
        //  Info
        ContentInfoPrimary: "#5C77FF",
        ContentInfoSecondary: "#8599FF",
        ContentInfoDefault: "#5C77FF",
        ContentInfoHover: "#8599FF",
        ContentInfoPressed: "#D6DDFF",
        //  Warning
        ContentWarningPrimary: "#FFD633",
        ContentWarningSecondary: "#FFE066",
        //  Negative
        ContentNegativePrimary: "#EA3333",
        ContentNegativeSecondary: "#EF6666",
        //  Positive
        ContentPositivePrimary: "#2EBA79",
        ContentPositiveSecondary: "#5DC996",

        //  BACKGROUND
        BackgroundPrimaryDefault: "#121212",
        BackgroundPrimaryHover: "#1F1F1F",
        BackgroundPrimaryPressed: "#4D4D4D",
        BackgroundSecondary: "#404040",
        BackgroundDisabled: "#333333",
        //  Elevated - for components inside dialogs
        BackgroundElevatedPrimaryDefault: "#1F1F1F",
        BackgroundElevatedPrimaryHover: "#333333",
        BackgroundElevatedSecondaryDefault: "#333333",
        BackgroundElevatedSecondaryHover: "#4D4D4D",
        //  Inverse
        BackgroundInverse: "#FFFFFF",
        //  Brand
        BackgroundBrandPrimary: "#00B6ED",
        BackgroundBrandPrimaryHover: "#6CCBF7",
        BackgroundBrandPrimaryPressed: "#C5E2F0",
        BackgroundBrandPrimarySubtle: "#001931",
        BackgroundBrandSecondary: "#C5E2F0",
        BackgroundBrandSecondaryHover: "#99D6F4",
        BackgroundBrandTertiary: "#1F1F1F",
        BackgroundBrandTertiaryHover: "#333333",
        BackgroundBrandTertiaryPressed: "#404040",
        //  Info
        BackgroundInfoPrimary: "#5C77FF",
        BackgroundInfoSecondary: "#142266",
        //  Warning
        BackgroundWarningPrimary: "#FFD633",
        BackgroundWarningSecondary: "#532909",
        //  Negative
        BackgroundNegativePrimary: "#EA3333",
        BackgroundNegativeSecondary: "#2E0000",
        BackgroundNegativeStatic: "#E50000",
        //  Positive
        BackgroundPositivePrimary: "#2EBA79",
        BackgroundPositiveSecondary: "#003200",
        //  Tooltip
        BackgroundTooltip: "#333333",
        //  DataViz
        BackgroundDataVizPositive: "#003200",
        BackgroundDataVizWarning: "#854A0E",
        BackgroundDataVizNegative: "#5C0000",
        BackgroundDataVizTrendEvent: "#0D5850",
        BackgroundDataVizInfoEvent: "#7C8392",
        //  BORDER
        BorderPrimary: "#999999",
        BorderSecondary: "#666666",
        BorderDisabled: "#4D4D4D",
        //  Elevated - for components inside dialogs
        BorderElevatedPrimary: "#999999",
        BorderElevatedSecondary: "#4D4D4D",
        //  Brand
        BorderBrandPrimary: "#00B6ED",
        BorderBrandPrimarySubtle: "#043D64",
        BorderBrandSecondary: "#666666",
        BorderBrandSecondaryHover: "#999999",
        BorderBrandTertiary: "#333333",
        //  Inverse
        BorderInverse: "#121212",
        //  Info
        BorderInfoPrimary: "#5C77FF",
        BorderInfoSecondary: "#1F3399",
        //  Warning
        BorderWarningPrimary: "#FFD633",
        BorderWarningSecondary: "#A15C07",
        //  Negative
        BorderNegativePrimary: "#EA3333",
        BorderNegativeSecondary: "#890000",
        //  Positive
        BorderPositivePrimary: "#2EBA79",
        BorderPositiveSecondary: "#00651D",

        //  OVERLAY
        // Overlay50: "#00000080",
        // Overlay50Inverse: "#FFFFFF80",
      },
    },
  },
  icons: {
    ...CustomIcons,
  },
});

/**
 * Helper function to get theme color from vuetify instance
 * Can be used in knockout components to access current theme colors
 * @param color - The color name from the theme (e.g., 'ContentPrimary', 'BackgroundBrandPrimary')
 * @returns The color value as a string
 */
export function getThemeColor(color: string): string {
  const isDark = vuetifyInstance.framework.theme.dark;
  const theme = isDark ? vuetifyInstance.framework.theme.themes.dark : vuetifyInstance.framework.theme.themes.light;
  return (theme as any)[color] ?? vuetifyInstance.framework.theme.themes.light[color];
}

export default vuetifyInstance;
